export default () => ({
  actions: {
    justifyContent: 'center',
  },
});
